import { API_URL } from '../config/api';

export type LocationHierarchy = Record<string, Record<string, Record<string, string[]>>>;
const getBaseUrl = () => (API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL);

const fetchJson = async <T>(path: string): Promise<T> => {
  const response = await fetch(`${getBaseUrl()}${path}`, {
    method: 'GET',
    credentials: 'omit',
  });
  if (!response.ok) {
    throw new Error(`Failed request: ${response.status}`);
  }
  return response.json() as Promise<T>;
};

export const locationApi = {
  getHierarchy: async (): Promise<LocationHierarchy> => {
    try {
      const data = await fetchJson<LocationHierarchy>('/locations/hierarchy');
      return data || {};
    } catch (error) {
      console.warn('Failed to fetch location hierarchy from API.', error);
      return {};
    }
  },
  getStates: async (): Promise<string[]> => {
    try {
      return (await fetchJson<string[]>('/locations/states')) || [];
    } catch (error) {
      console.warn('Failed to fetch states from API.', error);
      return [];
    }
  },
  getDistricts: async (state: string): Promise<string[]> => {
    if (!state) return [];
    try {
      return (
        await fetchJson<string[]>(`/locations/districts?state=${encodeURIComponent(state)}`)
      ) || [];
    } catch (error) {
      console.warn('Failed to fetch districts from API.', error);
      return [];
    }
  },
  getMandals: async (state: string, district: string): Promise<string[]> => {
    if (!state || !district) return [];
    try {
      return (
        await fetchJson<string[]>(
          `/locations/mandals?state=${encodeURIComponent(state)}&district=${encodeURIComponent(district)}`,
        )
      ) || [];
    } catch (error) {
      console.warn('Failed to fetch mandals from API.', error);
      return [];
    }
  },
  getVillages: async (state: string, district: string, mandal: string): Promise<string[]> => {
    if (!state || !district || !mandal) return [];
    try {
      return (
        await fetchJson<string[]>(
          `/locations/villages?state=${encodeURIComponent(state)}&district=${encodeURIComponent(district)}&mandal=${encodeURIComponent(mandal)}`,
        )
      ) || [];
    } catch (error) {
      console.warn('Failed to fetch villages from API.', error);
      return [];
    }
  },
};
